import { Search } from "lucide-react";
import React from "react";

import { IgBorderColors } from "@intelligems/ig-design-tokens/constants";
import { IgTextField } from "@intelligems/ig-theme/IgTextField";
import { useDispatch, useSelector } from "@src/store";
import {
  getProductPickerSearch,
  setProductPickerSearch,
} from "@src/store/slices/productPicker";

export const ProductSearch = () => {
  const search = useSelector(getProductPickerSearch);
  const dispatch = useDispatch();

  return (
    <IgTextField
      placeholder={"Search products"}
      value={search}
      onChange={(e) => void dispatch(setProductPickerSearch(e.target.value))}
      slotProps={{
        input: {
          endAdornment: <Search size={16} />,
        },
      }}
    />
  );
};
